import React, { FC } from "react";
import "./content-loaders.scss";

interface CourseListLoaderProps {
  count?: number;
}

const CourseListItemLoader: FC = () => (
  <div className="listBlock mb-2 contentLoader__courseItem" aria-hidden="true">
    <div className="row gutters-10 align-items-center">
      <div className="col-auto">
        <div className="imgBlock contentLoader__shimmer" />
      </div>
      <div className="col">
        <div className="row justify-content-between">
          <div className="col-12 col-lg-5">
            <div className="contentLoader__shimmer mb-2" style={{ height: 22, width: "70%" }} />
            <div className="contentLoader__shimmer" style={{ height: 14, width: "90%" }} />
          </div>
          <div className="col-12 col-lg-7">
            <div className="row gutters-5">
              {Array.from({ length: 6 }).map((_, index) => (
                <div className="col" key={index}>
                  <div className="contentLoader__shimmer mb-3" style={{ height: 12, width: "80%" }} />
                  <div className="contentLoader__shimmer" style={{ height: 16, width: "55%" }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto d-none d-md-block">
        <div className="contentLoader__shimmer" style={{ height: 24, width: 24, borderRadius: "50%" }} />
      </div>
    </div>
  </div>
);

const CourseListLoader: FC<CourseListLoaderProps> = ({ count = 3 }) => (
  <div className="contentLoader contentLoader--courses" aria-busy="true" aria-label="Loading courses">
    {Array.from({ length: count }).map((_, index) => (
      <CourseListItemLoader key={index} />
    ))}
  </div>
);

export default CourseListLoader;
